export const productShortName = 'Genetics & DNA Science — Teacher Ready';
export const productBrand = 'Genetics & DNA Science';
export const productEdition = 'Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/uGaSypYS3XLN7W9rn1c5iC/MOCKUP_GENETICS.png';
export const productImageAlt =
  'Genetics & DNA Science Teacher Ready: a 6-volume teaching collection covering DNA, Mendel and inheritance, gene expression, mutations and human genetics, biotechnology and CRISPR, and evolution and bioethics, plus five bonus resources';

export const checkoutUrl = 'https://genetics-dna-science.impultienda.ar/checkout';

export const price = '$27';
export const priceBefore = '$80';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = '$14';
export const bonusTotalValue = '$70';

export const closingLines = [
  'No more building every genetics lesson from scratch',
  'No more hunting for DNA diagrams and Punnett squares across the internet',
  'No more explaining genes, alleles and chromosomes without clear visuals',
  'No more improvising worked examples and classroom activities',
  'No more planning a genetics unit without a coherent path from DNA to evolution',
];
